/** Successful visits are independent of the server's changing task order. */
export type CellVisitTrail = { ids: number[]; cursor: number };
export const emptyTrail = (): CellVisitTrail => ({ ids: [], cursor: -1 });

export function readTrail(key: string): CellVisitTrail {
    try {
        const value = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (value && Array.isArray(value.ids) && value.ids.length > 0 &&
            value.ids.every((id: unknown) => Number.isSafeInteger(id) && Number(id) > 0) &&
            Number.isInteger(value.cursor) && value.cursor >= 0 && value.cursor < value.ids.length) {
            return value;
        }
    } catch { /* Storage can be unavailable or contain an older/invalid value. */ }
    return emptyTrail();
}

export function writeTrail(key: string, trail: CellVisitTrail) {
    try { sessionStorage.setItem(key, JSON.stringify(trail)); } catch { /* Navigation still works in memory. */ }
}

export function recordVisit(trail: CellVisitTrail, id: number, cursor?: number): CellVisitTrail {
    if (cursor !== undefined) return { ids: [...trail.ids], cursor };
    const ids = trail.ids.slice(0, trail.cursor + 1);
    if (ids[ids.length - 1] !== id) ids.push(id);
    return { ids, cursor: ids.length - 1 };
}

export function reconcileTrail(trail: CellVisitTrail, invalid: Set<number>): CellVisitTrail {
    const result = emptyTrail();
    trail.ids.forEach((id, index) => {
        if (invalid.has(id)) return;
        if (result.ids[result.ids.length - 1] !== id) result.ids.push(id);
        if (index <= trail.cursor) result.cursor = result.ids.length - 1;
    });
    return result;
}
